export const idPrivacy = {
    main: 'Ledgerowl menjaga privasi Kamu dengan sungguh-sungguh. Dengan menggunakan layanan kami, Kamu dianggap telah menyetujui kebijakan privasi ini.',
    contact: {
      email: 'support@ledgerowl.com',
      phone: '+6281287889023',
      address:
        'Gedung Cibis Nine Lt 15 Unit C, Jl TB Simatupang 2, Cilandak Timur, Pasar Minggu, Jakarta Selatan, DKI Jakarta 12560',
    },
    data: [
      {
        title: 'Yang Dicakup oleh Kebijakan Privasi ini',
        titleHref: '#privacypolicycover',
        text2: '',
        text: '',
        list: [
          {
            desc: 'Kebijakan Privasi ini mencakup perlakuan kami atas informasi yang dapat mengidentifikasi diri (data pribadi) Kamu saat sedang berada di situs Ledgerowl ataupun saat menggunakan layanan kami. Kebijakan ini juga mencakup perlakukan kami atas data pribadi yang digunakan bersama oleh kami.',
            sublist: [],
          },
          {
            desc: 'Kebijakan ini tidak berlaku pada praktik perusahaan yang bukan grup unit usaha milik kami atau di luar kendali kami atau pada orang-orang yang bukan karyawan kami atau di luar pengelolaan kami.',
            sublist: [],
          },
        ],
      },
      {
        title: 'Pengumpulan Informasi',
        text2: '',
        titleHref: '#collection',
        text: 'Saat Kamu melakukan registrasi dengan mengisi nama, email, alamat, tempat tinggal, tanggal lahir, kode pos, dan nomor telepon, Kamu akan terdaftar dan masuk ke layanan kami. Setelah registrasi dilakukan, maka Kamu bukanlah orang yang anonim bagi kami.',
        list: [],
      },
      {
        title: 'Penggunaan Informasi',
        text2: '',
        titleHref: '#useinformation',
        text: 'Setiap infomasi yang Kamu berikan dapat kami gunakan, termasuk namun tidak terbatas untuk:',
        list: [
          {
            desc: 'Memproses informasi Anda, termasuk namun tidak terbatas pada laporan keuangan, pengajuan perpajakkan, faktur penjualan atau pembelian, laporan usaha, dan lainnya;',
            sublist: [],
          },
          {
            desc: 'Mengantar surat atau barang yang Kamu beli dari kami;',
            sublist: [],
          },
          {
            desc: 'Menginformasikan pengembangan Produk, penawaran penjualan dan perawatan atau gangguan apa pun yang mungkin Kamu hadapi;',
            sublist: [],
          },
          {
            desc: 'Melakukan proses pembayaran; dan',
            sublist: [],
          },
          {
            desc: 'Mengetahui informasi kunjungan Anda, seperti waktu kunjungan dan apa yang Kamu lakukan dalam kunjungan tersebut.',
            sublist: [],
          },
          {
            desc: 'Kami juga dapat mengumpulkan dan menggunakan data Kamu yang tidak dapat diidentifikasi sebagai pribadi, untuk:',
            sublist: [],
          },
          {
            desc: 'Mengoptimalkan Produk, Situs, kampanye pemasaran, dan lainnya;',
            sublist: [],
          },
          {
            desc: 'Melihat efektifitas Situs dan Produk;',
            sublist: [],
          },
          {
            desc: 'Menemukan dan menyelesaikan masalah yang ada di Situs dan Produk; dan',
            sublist: [],
          },
          {
            desc: 'Mengembangkan Produk',
            sublist: [],
          },
        ],
      },
      {
        title: 'Perubahan terhadap Kebijakan Privasi ini',
        titleHref: '#change',
        text2: '',
        text: '',
        list: [
          {
            desc: 'Kami dapat mengubah kebijakan ini dari waktu ke waktu. Jika kami melakukan perubahan besar dalam cara penggunaan data pribadi Anda, kami akan memberi tahu Kamu dengan memasang pengumuman yang tampak jelas di halaman kami. Kamu setuju bahwa pemasangan pengumuman itu sudah cukup dan memadai untuk memberi tahu Kamu mengenai perubahan tersebut.',
            sublist: [],
          },
          {
            desc: 'Kamu setuju bahwa dengan terus menggunakan produk atau layanan kami setelah dilakukannya perubahan tersebut, Kamu menerima dan setuju untuk terikat dengan ketentuan dalam kebijakan yang baru.',
            sublist: [],
          },
        ],
      },
      {
        title: 'Pengungkapan Informasi Anda',
        text2: '',
        titleHref: '#disclosure',
        text: 'Kami dapat mengungkapkan informasi pribadi Kamu kepada pihak ketiga:',
        list: [
          {
            desc: 'Apabila kami menjual atau membeli suatu bisnis atau aset, dimana, dalam hal ini, kami dapat mengungkapkan data pribadi Kamu kepada calon penjual atau pembeli dari bisnis atau aset tersebut.',
            sublist: [],
          },
          {
            desc: 'Apabila kami berkewajiban mengungkapkan atau berbagi data pribadi Kamu dalam upaya mematuhi kewajiban hukum atau dalam upaya memberlakukan atau menerapkan syarat-syarat penggunaan kami dan perjanjian-perjanjian lain; atau untuk melindungi hak, properti, atau keselamatan Ledgerowl, pelanggan kami, atau pihak lain. Di sini termasuk pertukaran informasi dengan perusahaan dan organisasi lain untuk tujuan perlindungan terhadap penipuan dan pengurangan resiko kredit.',
            sublist: [],
          },
        ],
      },
      {
        title: 'Penggunaan Informasi',
        titleHref: '#useinformation',
        text2: '',
        text: 'Kami menggunakan informasi yang dimiliki mengenai Kamu dengan cara-cara sebagai berikut:',
        list: [
          {
            desc: 'Untuk memastikan bahwa isi dari situs kami disajikan dengan cara yang paling efektif untuk Kamu dan untuk komputer anda.',
            sublist: [],
          },
          {
            desc: 'Untuk memberikan kepada Kamu informasi, produk atau layanan yang Kamu minta dari kami atau yang kami rasa mungkin penting bagi anda, dimana Kamu setuju untuk dihubungi untuk tujuan tersebut.',
            sublist: [],
          },
          {
            desc: 'Untuk melaksanakan kewajiban kami yang timbul dari suatu kontrak yang diadakan antara Kamu dan kami.',
            sublist: [],
          },
          {
            desc: 'Untuk memungkinkan Kamu ambil bagian dalam fitur interaktif layanan kami, sewaktu Kamu memilih demikian.',
            sublist: [],
          },
          {
            desc: 'Untuk memberitahu Kamu mengenai perubahan terhadap layanan kami.',
            sublist: [],
          },
        ],
      },
      {
        title: 'Hak Anda',
        titleHref: '#youright',
        text: 'Kamu berhak meminta kami untuk tidak memproses data pribadi Kamu untuk tujuan pemasaran. Kami akan memberitahu Kamu (sebelum mengumpulkan data anda) apabila kami bermaksud menggunakan data Kamu untuk tujuan tersebut atau apabila kami bermaksud mengungkapkan informasi Kamu kepada pihak ketiga untuk tujuan tersebut. Kamu dapat menggunakan hak Kamu untuk mencegah pemrosesan tersebut dengan menghubungi kami di ',
        text2:
          'Situs kami, dapat berisi link ke dan/atau dari situs web jaringan mitra, pengiklan dan afiliasi kami. Apabila Kamu mengikuti link ke salah satu dari situs-situs web ini, perlu diperhatikan bahwa situs-situs web ini memiliki kebijakan hak-pribadinya sendiri dan kami tidak memiliki tanggung jawab atau menanggung kewajiban atas kebijakan tersebut. Silakan periksa kebijakan ini sebelum Kamu menyerahkan data pribadi ke situs-situs web ini.',
        list: [],
      },
      {
        title: 'Perubahan atas Kebijakan Hak-Pribadi Kami',
        titleHref: '#changestoour',
        text: 'Perubahan yang dapat kami lakukan atas kebijakan hak-pribadi kami di masa mendatang akan ditempatkan di halaman ini dan, bilamana dipandang tepat, akan diberitahukan kepada Kamu melalui e-mail.',
        text2: '',
        list: [],
      },
      {
        title: 'Pihak yang dapat Dihubungi',
        titleHref: '#contact',
        text2: '',
        text: 'Pertanyaan, komentar dan saran mengenai kebijakan hak-pribadi ini akan disambut baik dan dapat dikirimkan ke alamat berikut:',
        list: [],
      },
    ],
  }